import type { ComponentProps } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { loadSessionsForDate } from '../../actions/dateSessions';
import { loadDatesForMonth } from '../../actions/eventDates';
import {
    setSection,
    setSelectedDate,
    setSelectedTime,
    setTicketSectionLoading,
    type InfiniteCalendarSeriesDispatcher,
} from '../../actions/infiniteCalendarSeries';
import { getTemplateProps } from '../../containers/template';
import { getAppLocale, getIsAppRebrandActive } from '../../selectors/app';
import {
    getActiveSection,
    getCalendarData,
    getCalendarType,
    getIsDateSectionLoading,
    getIsTicketSectionLoading,
    getIsTimeSectionLoading,
    getParentEventInfo,
    getSelectedDate,
    getSelectedTime,
    getShouldShowTicketError,
    getShouldShowTimeError,
    getShouldShowTimeSection,
    getTimeSlots,
    getTimezone,
} from '../../selectors/infiniteCalendarSeries/infiniteCalendarSeries';
import type { CheckoutState } from '../../state';
import {
    AccordionSection,
    type InfiniteCalendarSeriesNamespace,
} from '../../state/infiniteCalendarSeries';
import { InfiniteCalendarSeries } from './InfiniteCalendarSeries';

export const connectInfiniteCalendarSeries = () =>
    connect(
        (state: CheckoutState): InfiniteCalendarSeriesNamespace => ({
            activeSection: getActiveSection(state),
            parentEventInfo: getParentEventInfo(state),
            locale: getAppLocale(state).replace('_', '-'),
            timezone: getTimezone(state),
            isAppRebrandActive: getIsAppRebrandActive(state),
            templateProps: getTemplateProps({ state, formName: '' }),
            calendarData: getCalendarData(state),
            calendarType: getCalendarType(state),
            timeSlots: getTimeSlots(state),
            isDateSectionLoading: getIsDateSectionLoading(state),
            isTimeSectionLoading: getIsTimeSectionLoading(state),
            isTicketSectionLoading: getIsTicketSectionLoading(state),
            shouldShowTimeError: getShouldShowTimeError(state),
            shouldShowTicketError: getShouldShowTicketError(state),
            selectedDate: getSelectedDate(state),
            selectedTime: getSelectedTime(state),
            shouldShowTimeSection: getShouldShowTimeSection(state),
        }),
        (
            dispatch: Dispatch<CheckoutState>,
        ): InfiniteCalendarSeriesDispatcher => ({
            onDateSelect: (dateString) => {
                dispatch(setSelectedDate(dateString));
                dispatch(loadSessionsForDate(dateString));
                dispatch(setSection(AccordionSection.time));
            },
            onTimeSelect: (_, sessionLabel) => {
                dispatch(setSelectedTime(sessionLabel));
                dispatch(setTicketSectionLoading(true));
                dispatch(setSection(AccordionSection.tickets));
            },
            onMonthLoad: async (monthAndYear) => {
                dispatch(loadDatesForMonth(monthAndYear));
            },
            onToggleSection: (sectionName) => {
                dispatch(setSection(sectionName));
            },
        }),
        (
            stateProps: InfiniteCalendarSeriesNamespace,
            dispatchProps: InfiniteCalendarSeriesDispatcher,
            ownProps: ComponentProps<typeof InfiniteCalendarSeries>,
        ) => ({
            ...ownProps,
            ...stateProps,
            ...dispatchProps,
        }),
    )(InfiniteCalendarSeries);

export const ConnectedInfiniteCalendarSeries = connectInfiniteCalendarSeries();
